// Brand constants — update social handles here and they propagate site-wide.
// Set to "" (empty string) to hide an icon until a real account exists.
export const socialLinks = {
  instagram: "https://www.instagram.com/wrongconception/",
  tiktok: "https://www.tiktok.com/@wrongconception",
  youtube: "", // Set to "" to hide the icon until a real channel exists
};

export const brandEmail = "hello@wrongconception.com";
